(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awf-minimal-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function clickBurger() {
    var candidates = Array.from(document.querySelectorAll('.js-burger-button, button[aria-controls="custom-drawer"]'));
    if (!candidates.length) return false;
    var el = candidates.find(function (el) {
      var s = window.getComputedStyle(el);
      return s.display !== 'none' && s.visibility !== 'hidden';
    }) || candidates[0];
    el.click();
    return true;
  }

  function openDrawerFallback() {
    var drawer = document.getElementById('custom-drawer');
    var backdrop = document.getElementById('drawer-backdrop');
    if (!drawer) return false;
    drawer.classList.add('opening', 'open');
    drawer.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    return true;
  }

  var trigger = document.getElementById('FooterMinorLogoTrigger');
  if (trigger) {
    trigger.addEventListener('click', function () {
      if (!clickBurger()) openDrawerFallback();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function clickBurger() {
    var candidates = Array.from(document.querySelectorAll('.js-burger-button, button[aria-controls="custom-drawer"]'));
    if (!candidates.length) return false;
    var el = candidates.find(function (el) {
      var s = window.getComputedStyle(el);
      return s.display !== 'none' && s.visibility !== 'hidden';
    }) || candidates[0];
    el.click();
    return true;
  }

  function openDrawerFallback() {
    var drawer = document.getElementById('custom-drawer');
    var backdrop = document.getElementById('drawer-backdrop');
    if (!drawer) return false;
    drawer.classList.add('opening', 'open');
    drawer.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    return true;
  }

  var trigger = document.getElementById('FooterMinorLogoTrigger');
  if (trigger) {
    trigger.addEventListener('click', function () {
      if (!clickBurger()) openDrawerFallback();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-drawer"]) return;
  try {
    
(function () {
  // Styles we want the LIVE burger drawer to use
  var CSS = `
#left-drawer-slot .drawer,
#left-drawer-slot .sidebar-container{
  background:#200202;        /* your dark */
  color:#F8F5F0;             /* creamy text */
}
#left-drawer-slot .border-gridline-color,
#left-drawer-slot .border-t-gridline,
#left-drawer-slot nav li,
#left-drawer-slot nav li + li{
  border:0; border-color:transparent;
}
/* subtle lift/slide on links + buttons */
#left-drawer-slot a,
#left-drawer-slot button{
  display:inline-block;
  text-decoration:none;
  background-image:none;
  box-shadow:none;
  border-radius:8px;
  transition:transform .35s cubic-bezier(.22,.61,.36,1),
             color .35s cubic-bezier(.22,.61,.36,1),
             background-color .35s cubic-bezier(.22,.61,.36,1);
  will-change:transform;
}
#left-drawer-slot a:hover,
#left-drawer-slot button:hover{
  transform:translateX(4px) translateY(-3px);
  background:rgba(181,26,26,.18); /* soft red wash */
}
/* animate SVGs (social icons + ‘A’ logo) */
#left-drawer-slot .social a svg,
#left-drawer-slot svg{
  transition:transform .35s cubic-bezier(.22,.61,.36,1);
}
#left-drawer-slot .social a:hover svg,
#left-drawer-slot svg:hover{
  transform:translateY(-3px);
}
/* search input polish */
#left-drawer-slot input[type="text"],
#left-drawer-slot input[type="search"]{
  color:#F8F5F0;
  background:rgba(255,255,255,.06);
  border:1px solid rgba(255,255,255,.12);
  border-radius:10px;
}
/* accessible focus ring */
#left-drawer-slot a:focus-visible,
#left-drawer-slot button:focus-visible{
  outline:2px solid rgba(255,255,255,.7);
  outline-offset:3px;
}
`;

  // Inject the <style> into the live drawer slot
  function inject() {
    var slot = document.getElementById('left-drawer-slot');
    if (!slot) return;
    if (!slot.querySelector('#awf-drawer-style')) {
      var s = document.createElement('style');
      s.id = 'awf-drawer-style';
      s.textContent = CSS;
      slot.appendChild(s);
    }
  }

  // Run now and whenever the DOM changes (drawer opens/teleports)
  inject();
  var mo = new MutationObserver(inject);
  mo.observe(document.body, { childList: true, subtree: true });
})();

  } catch(e) { console.error(e); }
})();
})();
